import { render, staticRenderFns } from "./ManageProjects.vue?vue&type=template&id=eead96b6&"
import script from "./ManageProjects.vue?vue&type=script&lang=js&"
export * from "./ManageProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports